export default __webpack_public_path__ + "static/media/tete25.0aa7c169.png";